import { useCallback, useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { defaultEventBus } from '../EventBus/defaultEventBus.js';
import { useLatestEvent } from '../EventBus/useLatestEvent.js';
import { fetchJSONUnsafe } from '../utils/fetchJSON.js';
const REGION_URL = '/api/v1/region';
const LOCATION_STORAGE_KEY = 'location';
export function useLocation(defaultLocation = 'Москва') {
    const [currentLocation, fireCurrentLocation] = useLatestEvent(defaultEventBus, 'location', restoreLocation() ?? { name: defaultLocation });
    const selectCurrentLocation = useCallback((_) => {
        storeLocation(_);
        fireCurrentLocation(_);
    }, []);
    const { data } = useAsyncData(hasStoredLocation() ? null : REGION_URL, fetchJSONUnsafe);
    useEffect(() => {
        if (data && !hasStoredLocation()) {
            fireCurrentLocation(data);
        }
    }, [data]);
    return [currentLocation ?? { name: defaultLocation }, selectCurrentLocation];
}
const hasStoredLocation = () => Boolean(globalThis.localStorage?.getItem(LOCATION_STORAGE_KEY));
const restoreLocation = () => {
    try {
        const data = globalThis.localStorage?.getItem(LOCATION_STORAGE_KEY);
        return data && JSON.parse(data);
    }
    catch (ex) {
        return null;
    }
};
const storeLocation = (_) => {
    try {
        globalThis.localStorage?.setItem(LOCATION_STORAGE_KEY, JSON.stringify(_));
    }
    catch (ex) {
        // Do nothing
    }
};
//# sourceMappingURL=useLocation.js.map